export default function DonateMoney() {
    return (
        <div className="max-w-4xl mx-auto p-8 bg-[#f97316] rounded-lg">
            <h1 className="text-6xl font-bold text-center text-white mb-4">Support Our Cause</h1>
            <h2 className="text-2xl font-semibold text-center text-white mb-8">Leave a One-Time Donation</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                <div className="flex items-center justify-center col-span-3">
          <button
          type="button"
          className="rounded-md bg-white h-14 w-28 px-3.5 py-2.5 text-sm font-semibold text-black shadow-sm hover:bg-orange-100"
          onClick={() =>{
            const url = 'https://www.paypal.com/donate/?hosted_button_id=YLAQ7KXG2N8AL';

            const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
          }} style={{cursor: 'pointer'}}
          >Donate</button>
        </div>

            </div>

        </div>
    )
}
